import type { SearchScope } from "@/lib/search-types";

/**
 * The address of a report can open "Search your full file" already filled in:
 *   /report/<jobId>?q=BRCA1&scope=gene     (a gene)
 *   /report/<jobId>?q=rs1799966&scope=rsid (a variant)
 * genome.coach's chat links here ("see the complete list with every annotation"). Anything
 * malformed is ignored rather than raising, so a hand-edited or truncated address still opens
 * the report normally. Pure, so it is unit-tested directly (report-search-params.test.ts).
 */
export const SEARCH_SCOPES: readonly SearchScope[] = ["any", "gene", "rsid", "disease", "drug"];

export type ReportSearchParams = { q?: string; scope?: SearchScope };

const MAX_TERM_LENGTH = 80;

export function parseReportSearchParams(search: Record<string, unknown>): ReportSearchParams {
  // The router turns numeric-looking values into numbers (?q=1234), so accept those too.
  const raw = search["q"];
  const text = typeof raw === "string" ? raw : typeof raw === "number" ? String(raw) : "";
  const printable = Array.from(text, (ch) => {
    const code = ch.charCodeAt(0);
    return code < 32 || code === 127 ? " " : ch;
  }).join("");
  const q = printable.trim().slice(0, MAX_TERM_LENGTH);
  if (!q) return {};
  const scope = SEARCH_SCOPES.find((s) => s === search["scope"]);
  return scope ? { q, scope } : { q };
}
